module.exports = __webpack_public_path__ + "static/img/cover15.b67093f7.jpg";